"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OutsmartlyScript = OutsmartlyScript;

var React = _interopRequireWildcard(require("react"));

var _env = require("./env.js");

var _htmlSafeJSONStringify = require("./htmlSafeJSONStringify.js");

var _overridesByPathname = require("./overridesByPathname.js");

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function OutsmartlyScript() {
  if (_env._outsmartly_enabled && _env._outsmartly_dev_mode) {
    var config = (0, _overridesByPathname.getCurrentOverrides)();

    if (config && !config.isLoading) {
      return React.createElement('script', {
        id: '__OUTSMARTLY_DATA__',
        type: 'application/json',
        dangerouslySetInnerHTML: {
          __html: (0, _htmlSafeJSONStringify.htmlSafeJSONStringify)(config.data)
        }
      });
    } // Do not early return! The empty script tag is needed
    // when not in dev mode.

  }

  return React.createElement('script', {
    id: '__OUTSMARTLY_DATA__',
    type: 'application/json'
  });
}